import { render, staticRenderFns } from "./finished-content.vue?vue&type=template&id=54273428&scoped=true"
import script from "./finished-content.vue?vue&type=script&lang=js"
export * from "./finished-content.vue?vue&type=script&lang=js"
import style0 from "./finished-content.vue?vue&type=style&index=0&id=54273428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54273428",
  null
  
)

export default component.exports